import script from './SdsPasswordStrength.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sds-password-strength",attrs:{"aria-valuenow":_vm.currentPercentageValue,"role":"progressbar"}},[_c('div',{staticClass:"sds-password-strength__bar",class:( _obj = {}, _obj[("sds-password-strength__bar--" + _vm.passwordStrength)] = true, _obj ),style:({ width: (_vm.currentPercentageValue + "%") })})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-2c79ebb1_0", { source: ".sds-password-strength[data-v-2c79ebb1]{height:3px;overflow:hidden;border-radius:var(--radius-full);background:var(--system-border-on-elevation-secondary)}.sds-password-strength__bar[data-v-2c79ebb1]{height:100%;background-color:var(--system-graphics-on-elevation-warning);border-radius:var(--radius-full)}.sds-password-strength__bar--1[data-v-2c79ebb1]{background-color:var(--system-graphics-on-elevation-danger)}.sds-password-strength__bar--4[data-v-2c79ebb1]{background-color:var(--system-graphics-on-elevation-success)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-2c79ebb1";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
